import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';

// Token-backed text input. forwardRef so react-hook-form's register() can attach.
export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className = '', ...rest }, ref) {
    return (
      <input
        ref={ref}
        className={[
          'h-10 w-full rounded-sm border border-line-2 bg-surface px-3 text-sm text-ink',
          'outline-none transition-[border-color,box-shadow] placeholder:text-muted-2',
          'focus:border-ink-3 focus:shadow-[0_0_0_3px_color-mix(in_oklch,var(--ink)_10%,transparent)]',
          className,
        ].join(' ')}
        {...rest}
      />
    );
  },
);
